export default __webpack_public_path__ + "static/media/330_private03-it-mobile.d3da395c.png";